<template>
  <div class="istorija">
    <v-container>
      <v-row class="text-center flex-column margin-center">
        <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthFirst}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintFirst}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagFirst}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiFirst}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalFirst() }}</h2></div>
          </div>
        </v-col>
        <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthSecond}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintSecond}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagSecond}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiSecond}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalSecond() }}</h2></div>
          </div>
        </v-col>
        <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthThird}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintThird}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagThird}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiThird}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalThird() }}</h2></div>
          </div>
        </v-col>
         <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthFourth}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintFourth}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagFourth}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiFourth}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalFourth() }}</h2></div>
          </div>
        </v-col>
         <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthFifth}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintFifth}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagFifth}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiFifth}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalFifth() }}</h2></div>
          </div>
        </v-col>
      <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthSixth}}:</li>
              <li class="history-list-item text-font mb-3">BLUE PRINT: {{history.blueprintSixth}}</li>
              <li class="history-list-item text-font mb-3">SWAG: {{history.swagSixth}}</li>
              <li class="history-list-item text-font mb-3">FEBI: {{history.febiSixth}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalSixth() }}</h2></div>
          </div>
        </v-col>
        <v-col>
          <div class="col pl-0 pr-0 history-wrapper">
            <ul v-for="history in history" v-bind:key="history" class="d-flex flex-column mb-4 history-list align-start">
              <li class="history-list-item text-font mb-3 text-font history-list-title">{{history.monthSeventh}}:</li>
              <li class="history-list-item text-font mb-3">Dodatni bonus na rast: {{history.blueprintSeventh}}</li>
            </ul>
            <div><h2 class="text-font history-total">{{ getTotalSeventh() }}</h2></div>
          </div>
        </v-col> 
      </v-row>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase'
import {db,fb} from '../main'

export default {
  name: 'History',
  data() {
    return {
        history: [],

      }
    },
    methods:{
      readData() {
          const user = fb.auth().currentUser
          db.collection(`accounts`).doc(user.uid).collection('history').get().then((querySnapshot) => { if (!querySnapshot.empty){
          querySnapshot.forEach((doc) => {
              this.history.push(doc.data())
              })
              db.collection(`accounts`).doc(user.uid).collection('history').doc("2").add({
                  monthFirst:'April',
                  monthSecond:'Maj',
                  monthThird:'Jun',
                  monthFourth:'Jul',
                  monthFifth:'Avgust',
                  monthSixth:'Septembar',
                  monthSeventh:'Bonus',
              })
            }
            else  {
               db.collection(`accounts`).doc(user.uid).collection('history').doc("2").set({
                    monthFirst:'April',
                    monthSecond:'Maj',
                    monthThird:'Jun',
                    monthFourth:'Jul',
                    monthFifth:'Avgust',
                    monthSixth:'Septembar',
                    monthSeventh:'Bonus',
    
                    blueprintFirst: 0,
                    swagFirst: 0,
                    febiFirst: 0,
                    blueprintSecond: 0,
                    swagSecond: 0,
                    febiSecond: 0,
                    blueprintThird: 0,
                    swagThird: 0,
                    febiThird: 0,
                    blueprintFourth: 0,
                    swagFourth: 0,
                    febiFourth: 0,
                    blueprintFifth: 0,
                    swagFifth: 0,
                    febiFifth: 0,
                    blueprintSixth: 0,
                    swagSixth: 0,
                    febiSixth: 0,
                    blueprintSeventh: 0

                })
              if(!window.location.hash) {
                  window.location = window.location + '#loaded';
                  window.location.reload();
              }
              
            }
          }) 
          
        },
        getTotalFirst() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiFirst+cur.blueprintFirst+cur.swagFirst), 0)
             if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
        getTotalSecond() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiSecond+cur.blueprintSecond+cur.swagSecond), 0)
             if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
        getTotalThird() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiThird+cur.blueprintThird+cur.swagThird), 0)
             if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
        getTotalFourth() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiFourth+cur.blueprintFourth+cur.swagFourth), 0)
             if (isNaN(totalPoints)) {
              return 0;
            }
          return totalPoints
        },
        getTotalFifth() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiFifth+cur.blueprintFifth+cur.swagFifth), 0)
          if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
        getTotalSixth() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.febiSixth+cur.blueprintSixth+cur.swagSixth), 0)
          if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
        getTotalSeventh() {
          const totalPoints = this.history.reduce((acc, cur) => acc + Number(cur.blueprintSeventh), 0)
          if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },
  },
    created() {
      this.readData()
    },

}
</script>

<style>
  .history-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #A7ADB1;
  }
  .history-list {
      list-style: none;
  }
  .history-list-title {
    font-size: 24px;
  }
  .history-total {
      color:#D11112;
      font-size: 3rem !important;
      font-weight: 400;
      line-height: 3.125rem;
      letter-spacing: normal !important;
      padding-right: 20px;
  }
</style>